import { Link, Theme, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useAuth } from 'components/AuthProvider'
import DefaultLayout from 'components/layout/DefaultLayout'
import { voucherReviewPath } from 'components/Routes/VoucherFlowRoutes'
import { walletPath } from 'components/Routes/Routes'
import { useEffect, useState } from 'react'
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom'
import { convertCamelCaseToWords } from '../../../utils/util'

const useStyles = makeStyles()((theme: Theme) => ({
  header: {
    textAlign: 'center',
    color: theme.palette.primary.main,
    fontSize: '3rem',
    marginTop: theme.spacing(4)
  },
  status: {
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    fontSize: '3rem'
  },
  message: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary
  },
  link: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    color: theme.palette.primary.main
  }
}))

export default function BlinkPayTransferStatus(): JSX.Element {
  const { state } = useLocation()
  const { setToast } = useAuth()
  const { classes } = useStyles()
  const navigate = useNavigate()

  const status = convertCamelCaseToWords(state?.status ?? 'N/A')
  const message = state?.message

  const redirectURL = localStorage.getItem('url_after_blinkpay_payment')
  const voucherForm = localStorage.getItem('voucher_form')

  const [showWalletLink] = useState(() => !redirectURL && !voucherForm)

  useEffect(() => {
    if (redirectURL || voucherForm) {
      const toastType: 'success' | 'error' | 'info' =
        state?.status === 'processing'
          ? 'info'
          : state?.success
          ? 'success'
          : 'error'
      setToast({
        message: state?.message,
        open: true,
        duration: 5000,
        type: toastType
      })
      if (redirectURL) {
        localStorage.removeItem('url_after_blinkpay_payment')
        navigate(redirectURL)
      } else if (voucherForm) {
        localStorage.removeItem('voucher_form')
        navigate(voucherReviewPath(), {
          state: JSON.parse(voucherForm ?? '')
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DefaultLayout backgroundColor='white'>
      <Typography variant='h1' component='h1' className={classes.header}>
        BLINKPAY PAYMENT
      </Typography>
      <Typography variant='h2' className={classes.status}>
        {status}
      </Typography>
      {message && (
        <Typography variant='body1' className={classes.message}>
          {message}
        </Typography>
      )}
      {showWalletLink && (
        <Typography variant='body1' className={classes.link}>
          <Link component={RouterLink} to={walletPath()} underline='always'>
            Go back to wallet
          </Link>
        </Typography>
      )}
    </DefaultLayout>
  )
}
